import { atom } from "jotai";
//  export const postulantesAtom = atom([]);
//  export const postulanteSeleccionadoAtom = atom(undefined);
//  export const postulantesAgregadosAtom =atom ([]);
export const cargosAtom = atom([]);
export const responsablesAtom = atom([]);
export const responsableSeleccionadoAtom = atom (undefined);